import type { DefaultValues, FieldValues } from 'react-hook-form'
import { z } from 'zod'

import type { InferMessageEditorOutput } from '@/modules/message/components/editor/message-editor-context'
import { MessageMediaSchema } from '@/modules/message/service/message-service'

import { type MessageBase } from '../sequence/message-sequence-editor-table'
import { type MediaSelection } from './fields/message-media-dropdown'

export const defaultComponents = [
  'text',
  'media',
  'price',
  'fallback',
  'customAndFanNameLabels',
] as const

export const allComponents = [
  'title',
  'text',
  'media',
  'price',
  'fallback',
  'customAndFanNameLabels',
  'fanName',
  'customName',
] as const

export type MessageEditorComponent = (typeof allComponents)[number]

export type DefaultMessageEditorValues<T extends FieldValues> = DefaultValues<
  InferMessageEditorOutput<T>
>

export type MessageFormValues = MessageBase & {
  medias?: MediaSelection[]
}

const FallbackValues = z.object({
  fallback: z.string().optional().nullish(),
  fallbackVariable: z.string().optional().optional().nullish(),
  enableFallbackVariable: z.boolean().default(false),
})

export const DefaultSchemaBase = FallbackValues.extend({
  id: z.number().optional().nullish(),
  text: z.string({ required_error: 'Text must be provided' }),
  price: z
    .number({
      invalid_type_error: 'Invalid price',
    })
    .nonnegative('Price must be positive')
    .nullable()
    .optional(),
  medias: z.array(MessageMediaSchema).optional(),
  sorting: z.number().optional().nullish(),
})
